import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    productId: string;
    unitOfMeasure: string;
    qtyOrdered: number;
    pageType: "PDP" | "PLP";
};

type Props = {
    product?: ProductModel;
    productInfosById?: SafeDictionary<ProductInfo>;
    pricingLoaded?: true;
};

type HandlerType = Handler<Parameter, Props>;

export const UpdateProductPricing: HandlerType = async props => {
    // if (!props.product || !props.productInfosById) {
    //     return;
    // }

    // const productInfo = props.productInfosById[props.product.id];
    // if (!productInfo) {
    //     return;
    // }
    const { productId, pageType, qtyOrdered, unitOfMeasure } = props.parameter;

    if (pageType === "PDP") {
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: [{ productId, unitOfMeasure, qtyOrdered }],
                onComplete: pricingProps => {
                    if (pricingProps.apiResult) {
                        const pricing = pricingProps.apiResult.realTimePricingResults!.find(
                            o => o.productId === productId,
                        );
                        if (pricing) {
                            props.dispatch({
                                type: "Pages/ProductDetails/CompleteLoadRealTimePricing",
                                pricing,
                            });
                        } else {
                            props.dispatch({
                                type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                                productId,
                            });
                        }
                    } else if (pricingProps.error) {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                            productId,
                        });
                    }

                    props.pricingLoaded = true;
                },
            }),
        );

        if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
            await waitFor(() => !!props.pricingLoaded);
        }
    } else if (pageType === "PLP") {
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: [{ productId, unitOfMeasure, qtyOrdered }],
                onSuccess: realTimePricing => {
                    props.dispatch({
                        type: "Pages/ProductList/CompleteLoadRealTimePricing",
                        realTimePricing,
                    });
                    props.pricingLoaded = true;
                },
                onError: () => {
                    props.dispatch({
                        type: "Pages/ProductList/FailedLoadRealTimePricing",
                    });
                    props.pricingLoaded = true;
                },
                onComplete(realTimePricingProps) {
                    if (realTimePricingProps.apiResult) {
                        this.onSuccess?.(realTimePricingProps.apiResult);
                    } else if (realTimePricingProps.error) {
                        this.onError?.(realTimePricingProps.error);
                    }
                },
            }),
        );

        if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
            await waitFor(() => !!props.pricingLoaded);
        }
    }
};

export const chain = [UpdateProductPricing];

const customUpdateProductPricing = createHandlerChainRunner(chain, "CustomUpdateProductPricing");
export default customUpdateProductPricing;